import service2 from '@/utils/request2'

/**
 * 触发设备截屏
 * POST /admin/api/screenshot/capture
 *
 * @param {string} deviceId 设备ID
 * @return {*}
 */
export const captureScreenshot = (deviceId) => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/screenshot/capture`,
    method: 'POST',
    params: { deviceId }
  })
}

/**
 * 查询截屏结果（JSON格式，包含Base64）
 * GET /admin/api/screenshot/result/{taskId}
 *
 * @param {string} taskId 任务ID
 * @return {*}
 */
export const getScreenshotResult = (taskId) => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/screenshot/result/${taskId}`,
    method: 'GET',
    // 截图结果是异步生成的，轮询期间的业务错误码属于正常状态，交由调用方处理
    hideError: true
  })
}

/**
 * 获取截图图片（返回PNG二进制）
 * GET /admin/api/screenshot/image/{taskId}
 *
 * @param {string} taskId 任务ID
 * @return {string} 图片URL
 */
export const getScreenshotImage = (taskId) => {
  // 返回图片URL，可以直接在浏览器中打开
  return `${process.env.VUE_APP_BASE_API}/cloud/edata-cloud-phone/admin/api/screenshot/image/${taskId}`
}

/**
 * 获取设备最新屏幕截图（使用旧机制）
 * GET /admin/api/screenshot/device-screen/{deviceId}
 *
 * @param {string} deviceId 设备ID
 * @return {string} 图片URL
 */
export const getDeviceScreen = (deviceId) => {
  return `${process.env.VUE_APP_BASE_API}/cloud/edata-cloud-phone/admin/api/screenshot/device-screen/${deviceId}`
}

/**
 * 健康检查
 * GET /admin/api/screenshot/health
 *
 * @return {*}
 */
export const getScreenshotHealth = () => {
  return service2({
    url: `/cloud/edata-cloud-phone/admin/api/screenshot/health`,
    method: 'GET'
  })
}
